var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row justify-center q-mt-xl desktop-hide" }, [
        !_vm.showMaintenance && !_vm.disableLoginForm
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "q-card",
                  { style: _vm.backgroundColor },
                  [
                    _c("q-card-title", { staticClass: "text-center" }, [
                      _c("img", {
                        staticClass: "logo-login",
                        attrs: { src: _vm.login_logo }
                      })
                    ]),
                    _c("q-card-separator"),
                    _c(
                      "q-card-main",
                      [
                        _vm.webinar_custom_login
                          ? _c("q-btn", {
                              staticClass: "full-width q-mb-lg",
                              attrs: {
                                color: "primary",
                                icon: "fas fa-sign-in-alt",
                                label: _vm.$t(
                                  "sign_in_with_user_email_and_password"
                                )
                              },
                              on: {
                                click: function($event) {
                                  _vm.webinar_custom_login = !_vm.webinar_custom_login
                                }
                              }
                            })
                          : _vm._e(),
                        !_vm.webinar_custom_login
                          ? _c("q-input", {
                              attrs: {
                                "lower-case": "",
                                dark: _vm.lightOrDark,
                                "float-label": _vm.$t(
                                  this.login_accept_document ? "user" : "login"
                                ),
                                error: _vm.$v.username.$error
                              },
                              on: { input: _vm.$v.username.$touch },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.login()
                                }
                              },
                              model: {
                                value: _vm.username,
                                callback: function($$v) {
                                  _vm.username = $$v
                                },
                                expression: "username"
                              }
                            })
                          : _vm._e(),
                        !_vm.webinar_custom_login
                          ? _c("q-input", {
                              attrs: {
                                dark: _vm.lightOrDark,
                                type: "password",
                                "float-label": _vm.$t("password"),
                                error: _vm.$v.password.$error
                              },
                              on: { input: _vm.$v.password.$touch },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.login()
                                }
                              },
                              model: {
                                value: _vm.password,
                                callback: function($$v) {
                                  _vm.password = $$v
                                },
                                expression: "password"
                              }
                            })
                          : _vm._e(),
                        _vm.showRegularLogin && !_vm.webinar_custom_login
                          ? _c("q-btn", {
                              staticClass: "full-width q-my-md",
                              attrs: {
                                color: _vm.colorSignIn,
                                icon: "fas fa-sign-in-alt",
                                label: _vm.$t("sign_in")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.login()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.showPopTradeOauth
                          ? _c("q-btn", {
                              staticClass: "full-width q-my-lg",
                              attrs: {
                                color: "primary",
                                icon: "fas fa-sign-in-alt",
                                label: _vm.$t("sign_in")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.loginPopTrade()
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.showSevenTradeOauth
                          ? _c("q-btn", {
                              staticClass: "full-width q-my-lg",
                              attrs: {
                                color: "primary",
                                icon: "fas fa-sign-in-alt",
                                label: _vm.$t("sign_in")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.loginSevenTrade()
                                }
                              }
                            })
                          : _vm._e(),
                        !_vm.webinar_custom_login
                          ? _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "text-secondary",
                                    style: _vm.fontColor,
                                    attrs: {
                                      to: {
                                        name: "recover-password",
                                        params: {
                                          email:
                                            _vm.username &&
                                            _vm.username.includes("@")
                                              ? _vm.username
                                              : "",
                                          document: ""
                                        }
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("forgot_password")))]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    (_vm.showRegister && !_vm.webinar_custom_login) ||
                    _vm.showPopTradeOauth ||
                    _vm.showSevenTradeOauth
                      ? _c("q-card-separator")
                      : _vm._e(),
                    (_vm.showRegister && !_vm.webinar_custom_login) ||
                    _vm.showPopTradeOauth ||
                    _vm.showSevenTradeOauth
                      ? _c(
                          "q-card-actions",
                          [
                            _vm.showRegister && !_vm.webinar_custom_login
                              ? _c("q-btn", {
                                  staticClass: "full-width q-my-sm",
                                  attrs: {
                                    color: "secondary",
                                    label: _vm.$t("sign_up")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push({
                                        name: "register"
                                      })
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.showPopTradeOauth
                              ? _c("q-btn", {
                                  staticClass: "full-width q-my-sm",
                                  attrs: {
                                    color: "secondary",
                                    label: _vm.$t("first_access")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push({
                                        name: "register-pop-trade"
                                      })
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.showSevenTradeOauth
                              ? _c("q-btn", {
                                  staticClass: "full-width q-my-sm",
                                  attrs: {
                                    color: "secondary",
                                    label: _vm.$t("first_access")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push({
                                        name: "register-seven-trade"
                                      })
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.login_recaptcha ? _c("q-card-separator") : _vm._e(),
                    _vm.login_recaptcha
                      ? _c("q-card-main", [
                          _c(
                            "div",
                            { staticClass: "text-faded text-center q-mb-sm" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "this_site_is_protected_by_googles_recaptcha"
                                    )
                                  ) +
                                  ".\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("do_apply")) +
                                  "\n\t\t\t\t\t\t"
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "text-secondary",
                                  attrs: {
                                    href: "https://policies.google.com/privacy",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("privacy_policy")))]
                              ),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("and")) +
                                  "\n\t\t\t\t\t\t"
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "text-secondary",
                                  attrs: {
                                    href: "https://policies.google.com/terms",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("terms_of_service")))]
                              ),
                              _vm._v("\n\t\t\t\t\t\t.\n\t\t\t\t\t")
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "login-image text-center text-white",
            class:
              _vm.disableLoginForm && !_vm.showMaintenance ? "col-12" : "col-6",
            style: {
              backgroundImage: "url(" + _vm.login_background + ")",
              borderRadius:
                _vm.disableLoginForm && !_vm.showMaintenance
                  ? "20px !important"
                  : "0 20px 20px 0 !important"
            }
          },
          [
            _c("div", { staticClass: "login-text" }, [
              _c("h2", [_vm._v(_vm._s(_vm.login_text_header))]),
              _c("p", [_vm._v(_vm._s(_vm.login_text))])
            ])
          ]
        )
      ]),
      _vm.showMaintenance
        ? _c(
            "div",
            { staticClass: "row justify-center q-mt-xl desktop-hide" },
            [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-card",
                    { style: _vm.backgroundColor },
                    [
                      _c("q-card-title", { staticClass: "text-center" }, [
                        _c("img", {
                          staticClass: "logo-login",
                          attrs: { src: _vm.login_logo }
                        })
                      ]),
                      _c("q-card-separator"),
                      _c(
                        "q-card-main",
                        { staticClass: "q-title q-py-lg text-weight-regular" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("maitenance_mode_text")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "q-card",
        { staticClass: "round-borders card-login mobile-hide fixed-center" },
        [
          _c("div", { staticClass: "row" }, [
            !_vm.showMaintenance && !_vm.disableLoginForm
              ? _c(
                  "div",
                  {
                    staticClass: "col-6 text-center q-px-xl",
                    style: _vm.backgroundColor
                  },
                  [
                    _c("img", {
                      staticClass: "q-pt-md logo-login",
                      attrs: { src: _vm.login_logo }
                    }),
                    _vm.webinar_custom_login
                      ? _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            icon: "fas fa-sign-in-alt",
                            label: _vm.$t(
                              "sign_in_with_user_email_and_password"
                            )
                          },
                          on: {
                            click: function($event) {
                              _vm.webinar_custom_login = !_vm.webinar_custom_login
                            }
                          }
                        })
                      : _vm._e(),
                    !_vm.webinar_custom_login
                      ? _c("q-input", {
                          attrs: {
                            dark: _vm.lightOrDark,
                            "float-label": _vm.$t(
                              this.login_accept_document ? "user" : "login"
                            ),
                            error: _vm.$v.username.$error
                          },
                          on: { input: _vm.$v.username.$touch },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.login()
                            }
                          },
                          model: {
                            value: _vm.username,
                            callback: function($$v) {
                              _vm.username = $$v
                            },
                            expression: "username"
                          }
                        })
                      : _vm._e(),
                    !_vm.webinar_custom_login
                      ? _c("q-input", {
                          attrs: {
                            dark: _vm.lightOrDark,
                            type: "password",
                            "float-label": _vm.$t("password"),
                            error: _vm.$v.password.$error
                          },
                          on: { input: _vm.$v.password.$touch },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.login()
                            }
                          },
                          model: {
                            value: _vm.password,
                            callback: function($$v) {
                              _vm.password = $$v
                            },
                            expression: "password"
                          }
                        })
                      : _vm._e(),
                    _vm.showRegularLogin && !_vm.webinar_custom_login
                      ? _c("q-btn", {
                          staticClass: "full-width q-my-lg",
                          attrs: {
                            color: _vm.colorSignIn,
                            icon: "fas fa-sign-in-alt",
                            label: _vm.$t("sign_in")
                          },
                          on: {
                            click: function($event) {
                              return _vm.login()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.showPopTradeOauth
                      ? _c("q-btn", {
                          staticClass: "full-width q-my-lg",
                          attrs: {
                            color: "primary",
                            icon: "fas fa-sign-in-alt",
                            label: _vm.$t("sign_in")
                          },
                          on: {
                            click: function($event) {
                              return _vm.loginPopTrade()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.showSevenTradeOauth
                      ? _c("q-btn", {
                          staticClass: "full-width q-my-lg",
                          attrs: {
                            color: "primary",
                            icon: "fas fa-sign-in-alt",
                            label: _vm.$t("sign_in")
                          },
                          on: {
                            click: function($event) {
                              return _vm.loginSevenTrade()
                            }
                          }
                        })
                      : _vm._e(),
                    !_vm.showPopTradeOauth && !_vm.webinar_custom_login
                      ? _c(
                          "router-link",
                          {
                            style: _vm.fontColor,
                            attrs: {
                              to: {
                                name: _vm.getRecoverPasswordRoute,
                                params: {
                                  email:
                                    _vm.username && _vm.username.includes("@")
                                      ? _vm.username
                                      : "",
                                  document: ""
                                }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("forgot_password")) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.login_recaptcha
                      ? _c("hr", { staticClass: "q-hr q-my-mg" })
                      : _vm._e(),
                    _vm.login_recaptcha
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-faded text-center q-body-1 q-mt-md"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "this_site_is_protected_by_googles_recaptcha"
                                  )
                                ) +
                                ".\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("do_apply")) +
                                "\n\t\t\t\t\t"
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "text-secondary",
                                attrs: {
                                  href: "https://policies.google.com/privacy",
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("privacy_policy")) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("and")) +
                                "\n\t\t\t\t\t"
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "text-secondary",
                                attrs: {
                                  href: "https://policies.google.com/terms",
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("terms_of_service")) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v("\n\t\t\t\t\t.\n\t\t\t\t")
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.showMaintenance
              ? _c(
                  "div",
                  {
                    staticClass: "col-6 text-center q-px-xl",
                    style: _vm.backgroundColor
                  },
                  [
                    _c("img", {
                      staticClass: "q-pt-xl logo-login",
                      attrs: { src: _vm.login_logo }
                    }),
                    _c("p", { staticClass: "q-headline q-mt-xl" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("maitenance_mode_text")) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "login-image text-center text-white",
                class:
                  _vm.disableLoginForm && !_vm.showMaintenance
                    ? "col-12"
                    : "col-6",
                style: {
                  backgroundImage: "url(" + _vm.login_background + ")",
                  borderRadius:
                    _vm.disableLoginForm && !_vm.showMaintenance
                      ? "20px !important"
                      : "0 20px 20px 0 !important"
                }
              },
              [
                _c("div", { staticClass: "login-text" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.login_text_header))]),
                  _c("p", [_vm._v(_vm._s(_vm.login_text))])
                ])
              ]
            )
          ])
        ]
      ),
      _c("vue-recaptcha", {
        ref: "invisibleRecaptcha",
        attrs: {
          size: "invisible",
          sitekey: _vm.recaptchaCode,
          loadRecaptchaScript: true,
          badge: "inline"
        },
        on: { verify: _vm.checkVerify }
      }),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              return _vm.hideError()
            }
          },
          model: {
            value: _vm.show_error,
            callback: function($$v) {
              _vm.show_error = $$v
            },
            expression: "show_error"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("login_error")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.custom_error_message
                  ? _vm.custom_error_message
                  : _vm.$t("username_password_incorrect")
              )
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }